<template>
  <div class="table-container">
    <el-button type="primary" style="margin-bottom: 15px" @click="addBtn(true, null)">
      添加分类
    </el-button>
    <el-table
    ref="tableSort"
    v-loading="listLoading"
    row-key="id"
    :data="list"
    element-loading-text="加载中"
    height="74vh"
    :default-expand-all="false"
    :tree-props="{children: 'sub', hasChildren: true}"
    border
    >
      <el-table-column align="left" prop="name"   min-width="180" show-overflow-tooltip label="名称"></el-table-column>
      <el-table-column align="center" prop="id" label="ID" min-width="90"></el-table-column>
      <el-table-column align="center" prop="update_time" label="修改时间" min-width="180"></el-table-column>
      <el-table-column fixed="right" align="center" show-overflow-tooltip label="操作面板" width="180px">
        <template #default="{ row }">
          {{ row.status == 0 ? '正常' : '关闭' }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" show-overflow-tooltip label="操作面板" width="180px">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" v-if="row.isFather" @click="addChild(true , row)">添加子分类</el-button>
          <el-popconfirm confirm-button-text="确认" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
            title="确认删除此条？" @confirm="del(row)">
            <el-button slot="reference" type="text" style="color: red; margin-left: 5px">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
      :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <!-- 新增/修改弹出层 -->
    <el-dialog :title="is_add ? '添加分类' : '修改分类'" :visible.sync="dialogFormVisible" top="15vh" width="800px"
      @close="close">
      <el-form v-if="dialogFormVisible" ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标题" prop="name">
          <el-input v-model.trim="form.name" autocomplete="off" placeholder="请输入标题" maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
        <!-- <el-form-item label="线路" prop="kor_type">
          <el-select v-model="form.kor_type" placeholder="请选择">
              <el-option
                v-for="(item , index) in countryList"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="父级" v-if="children_row.id" prop="name">
          <el-select v-model="parent_id" placeholder="请选择">
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    GoodsCate_list,
    GoodsCate_detail,
    GoodsCate_add,
    GoodsCate_update,
    GoodsCate_del,
    cate_list,
    Index_country_list
  } from '@/api/xgcApi'
  export default {
    name: 'Edit',
    components: {},
    data() {
      return {
        rules: {
          name: [{
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }],
          status: [{
            required: true,
            message: '请选择状态',
            trigger: ['blur', 'change'],
          }, ],
          kor_type: [{
            required: true,
            message: '请选择线路',
            trigger: ['blur', 'change'],
          }, ],
        },
        father_row:{},//父级信息
        children_row:{},
        parent_id:null,
        dialogFormVisible: false, //增加修改弹出
        form: {
          name: '',
          status: 0,
          kor_type:4
        }, //提交/修改的表单数据
        type_list:[
          {value:0 ,label:'韩到中'},
        ],
        list: [], //列表数据
        listLoading: false,
        layout: 'total, sizes, prev, pager, next, jumper',
        background: true,
        total: 0,
        is_add: true,
        queryForm: {
          page: 1,
          limit: 20,
          kor_type:4
        },
        countryList:[]
      }
    },
    beforeDestroy() {},
    mounted() {
      this.getList()
      this.getType_list()
    },
    methods: {
      getType_list(){
        // 获取线路
        // Index_country_list
        var data = {}
        Index_country_list(data).then(res=>{
          this.countryList = res.data
        })
      },
      // 编辑
      handleEdit(row) {
        this.listLoading = true
        this.is_add = false
        if(row.isFather){
          this.father_row = row
        }else{
          this.children_row = row
          this.parent_id = Number(row.pid)
        }
        GoodsCate_detail({
            id: row.id,
          })
          .then((res) => {
            this.form = res.data
            this.listLoading = false
            this.dialogFormVisible = true
          })
          .catch((err) => {
            this.listLoading = false
          })
      },
      submitForm() {
        // 提交表单
        var data = {
          name: this.form.name, //名称
          status: this.form.status, //0正常 1关闭
          kor_type:4,
          pic: '', //图片备用没有为空
        }
        this.listLoading = true
        if (this.is_add) {
          // 新增
          data.pid = this.father_row.id, //上级id
          data.pid_all = this.father_row.id?this.father_row.id:'', //上级id
          GoodsCate_add(data)
            .then((res) => {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.listLoading = false
              this.dialogFormVisible = false
              this.getList()
            })
            .catch((err) => {
              this.listLoading = false
            })
        } else {
          // 修改
          data.id = this.form.id
          this.listLoading = false
          data.pid = this.parent_id//上级id
          data.pid_all = this.children_row.pid?this.parent_id:'' //上级id
          GoodsCate_update(data)
            .then((res) => {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.listLoading = false
              this.dialogFormVisible = false
              this.getList()
            })
            .catch((err) => {
              this.listLoading = false
            })
        }
      },
      addChild(type, row){
        // 添加子分类
        if (type) {
          // 这个是新增
          this.is_add = true
          this.father_row = row
        } else {
          // 这个是修改
          this.is_add = false
        }
        this.dialogFormVisible = true
      },
      // 添加/修改
      addBtn(type, row) {
        if (type) {
          // 这个是新增
          this.is_add = true
        } else {
          // 这个是修改
          this.is_add = false
        }
        this.dialogFormVisible = true
      },
      // 对话框关闭
      close() {
        this.dialogFormVisible = false
        this.father_row = {}
        this.children_row = {}
        this.form = {}
      },
      del(row) {
        this.listLoading = true
        GoodsCate_del({
            id: row.id,
          })
          .then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.listLoading = false
            this.getList()
          })
          .catch((err) => {
            this.listLoading = false
          })
      },
      getList() {

        this.listLoading = true
        GoodsCate_list(this.queryForm)
          .then((res) => {
            res.data.map((item,index)=>{
              item.isFather = true
            })
            this.list = res.data
            console.log(this.list)
            this.total = this.list.length
            this.listLoading = false
          })
          .catch((err) => {
            this.listLoading = false
          })
      },

      handleCurrentChange(e) {
        this.queryForm.page = e
      },
      handleSizeChange(e) {
        this.queryForm.limit = e
      },
    },
  }
</script>

<style>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }
</style>
